import * as React from 'react';
// @ts-ignore
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader';
import { UpgradePlanData, UpgradePlanQuote, UpgradePlanTab, UpgradePlanTabKey } from 'admin/components/AdminUpgradePlan/AdminUpgradePlanContainer';

import '../styles/AdminUpgradePlanForms.scss';

type Props = {
  tabs: UpgradePlanTab[];
  fields: UpgradePlanData;
  quote: UpgradePlanQuote;
  submittingPayment: boolean;
  cardInputCompleted: boolean;
  cardError?: string;
  currentTab?: UpgradePlanTab;
  onNoOrgStats: () => void;
  onCardInputCompleted: () => void;
  onContactSales: () => Promise<void>;
  onPersistState: (fields: UpgradePlanData, quote: UpgradePlanQuote, onSuccess: Function) => void;
  onTaxExemptChange: (taxExempt: boolean) => void;
  onAcceptPlanTerms: (onSuccess: () => void) => void;
}

type State = {
  currentTab: UpgradePlanTab;
}


class AdminUpgradePlanForms extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      currentTab: props.currentTab || props.tabs[0],
    };
  }

  advanceTab = () => {
    const { nextStep } = this.state.currentTab;
    if (nextStep) {
      const newTab = this.props.tabs.find(tab => tab.tabKey === nextStep());
      if (newTab) {
        this.setState({ currentTab: newTab });
      }
    }
  };

  contactSales = async () => {
    await this.props.onContactSales();
    const contactSalesTab = this.props.tabs.find(tab => tab.tabKey === 'contact-sales');
    if (contactSalesTab) {
      this.setState({ currentTab: contactSalesTab });
    }
  };

  render() {
    const {
      fields,
      onNoOrgStats,
      onCardInputCompleted,
      onPersistState,
      onTaxExemptChange,
      onAcceptPlanTerms,
      quote,
      submittingPayment,
      cardInputCompleted,
      cardError,
    } = this.props;
    const { currentTab } = this.state;
    const CurrentTab = currentTab.component;

    return (
      <div className="AdminUpgradePlanForms">
        <AdminUpgradePageHeader title="The Remind plan" hideHelp />
        <div className="AdminUpgradePlanForms-body">
          <CurrentTab
            {...fields}
            quote={quote}
            onAdvance={this.advanceTab}
            onNoOrgStats={onNoOrgStats}
            onCardInputCompleted={onCardInputCompleted}
            onPersistState={onPersistState}
            onTaxExemptChange={onTaxExemptChange}
            onAcceptPlanTerms={onAcceptPlanTerms}
            onContactSales={this.contactSales}
            submittingPayment={submittingPayment}
            cardInputCompleted={cardInputCompleted}
            cardError={cardError}
          />
        </div>
      </div>
    );
  }
}


export { AdminUpgradePlanForms };
export default AdminUpgradePlanForms;
